import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { Creators as scheduling } from "../../store/ducks/scheduling";

import "./Scheduling.scss";
import messages from "../../assets/i18n";
import { SelectDate, SelectHour, SelectGate } from "../../components/";
import _ from "lodash";

function Scheduling (props) {
	
	const dispatch = useDispatch();

	const [weekday, setWeekday] = useState('');

	const lang = useSelector(state => state.language.name);
	const hour = useSelector(state => state.scheduling.hour);
	const gate = useSelector(state => state.scheduling.gate);

	const { freeGates } = props

	const getScheduling = bindActionCreators(scheduling, dispatch)

	useEffect(() => {
		clearState();
		getScheduling.idLoad(props.freeGates.idCarga);
	// eslint-disable-next-line
	},[])

	const clearState = () => {
		getScheduling.clearHour();
		getScheduling.clearGate();
	};

	const selectDate = (newDate, weekday) => {
		clearState();
		setWeekday(weekday);

		getScheduling.selectDate(newDate);
	};

	const selectHour = hour => {
		getScheduling.selectHour(hour);
		getScheduling.clearGate();
	};

	const selectGate = gate => {
		getScheduling.selectGate(gate);
	};

	const getHoursFromDay = day => {
		if (freeGates !== undefined && Object.entries(freeGates).length > 0) {
			let hours = [];

			freeGates.portoes.map(portao => {
				// eslint-disable-next-line array-callback-return
				return portao.listaHorarios.map(dias => {
					if (numToDayInitial(dias.diaSemana) === day) {
						hours.push(dias.horariosDisponiveis);
					}
				});
			});
			return _.uniq(_.flatten(hours)).sort();
		}

	};

	const getGatesFromHour = (hour, day) => {
		if (freeGates !== undefined && Object.entries(freeGates).length > 0) {
			let gates = [];

			freeGates.portoes.map(portao => {
				// eslint-disable-next-line array-callback-return
				return portao.listaHorarios.map(dias => {
					if (numToDayInitial(dias.diaSemana) === day) {
						// eslint-disable-next-line array-callback-return
						return dias.horariosDisponiveis.map(hora => {
							if (hora === hour) {
								gates.push(portao)
							}
						})
					}
				})
			})

			return _.uniq(gates).sort();
		}
	}

	const numToDayInitial = dayWeeksNum => {
		const weeksDays = {
		1: "Sun",
		2: "Mon",
		3: "Tue",
		4: "Wed",
		5: "Thu",
		6: "Fri",
		7: "Sat"
		}
		return weeksDays[dayWeeksNum]
	}

	const getAlldays = () => {
		if (freeGates && Object.entries(freeGates).length > 0) {
			let days = {
				Sun: { date: '', hours: [] },
				Mon: { date: '', hours: [] },
				Tue: { date: '', hours: [] },
				Wed: { date: '', hours: [] },
				Thu: { date: '', hours: [] },
				Fri: { date: '', hours: [] },
				Sat: { date: '', hours: [] },
			}

			freeGates.portoes.map(portao => {
				return portao.listaHorarios.map(dias => {
					return [
						days[numToDayInitial(dias.diaSemana)].date = dias.data,
						days[numToDayInitial(dias.diaSemana)].hours += dias.horariosDisponiveis
					]
				})
			})

			return days;
		}
	}
	
	return (
			<Container className="scheduling pb-5 mb-5">
				<Row>
					<Col className="px-0">
						<SelectDate days={getAlldays()} functionProps={selectDate} />

						<hr />

						{weekday !== "" ? (
							<Fragment>
								<SelectHour
									hours={getHoursFromDay(weekday)}
									setHourFuncCallback={selectHour} // no filho, seta hora no pai
									selectedHourFromParent={hour} // manda state do pai pro filho
								/>
								<hr />
							</Fragment>
						) : Object.entries(freeGates).length > 0 
								? <p className="messages">{messages[lang].selectOneDay}</p>
								: ''
						}

						{hour !== '' ? (
							<SelectGate
								gates={getGatesFromHour(hour, weekday)}
								setGateFuncCallback={selectGate}
								selectedGateFromParent={gate}
							/>
						) : ''
						}
					</Col>
				</Row>
			</Container>
	);
}

export default Scheduling;
